import client from './requestclient';

const partners = {
    dashboard: async (id) => {
        return await client({URL_PATH: `partner-dashboard/${id}`, method: "GET"})
    },

    userCheck: async (id) => {
        return await client({URL_PATH: `check-user-profiles/${id}`, method: "GET"})
    },

    facilityDasboard: async (id) => {
        return await client({URL_PATH: `partner-property-management/${id}`, method: "GET"})
    },
    respondRequest: async (body) => {
        return await client({URL_PATH: `respond-to-property-assignment-request`, method: "POST", body: body})
    },
    respondPartnersRequest: async (body) => {
        return await client({URL_PATH: `respond-to-partner-property-managent-request`, method: "POST", body: body})
    },
    
    propertyInspectionRequests: async (id) => {
        return await client({URL_PATH: `fetch-partner-properties-inspection-request/${id}`, method: "GET"})
    },
    propertyManagementRequests: async (id) => {
        return await client({URL_PATH: `fetch-partner-properties-management-request/${id}`, method: "GET"})
    },
    propertyMaintainanceRequests: async (id) => {
        return await client({URL_PATH: `partner-view-maintenance-requests/${id}`, method: "GET"})
    },
    propertyFMIORequests: async (id) => {
        return await client({URL_PATH: `view-fm-io-requests/${id}`, method: "GET"})
    },

    fetchAllRequests: async (id) => {
        return await client({URL_PATH: `fetch-all-request/${id}`, method: "GET"})
    },

    partnerPropertyManagementRequests: async (id) => {
        return await client({URL_PATH: `partner-property-management-request/${id}`, method: "GET"})
    },

    smartConfiguration: async (id) => {
        return await client({URL_PATH: `smart-configurations/${id}`, method: "GET"})
    },

    respondToPropertyMaintainanceFMIORequest: async (body, url) => {
        return await client({URL_PATH: `${url}`, method: "POST", body: body})
    },

    requestCount: async (id) => {
        return await client({URL_PATH: `fetch-associate-request-counts/${id}`, method: "GET"})
    },

    uploadVendorWorkSamples: async (formData) => {
        return await client({
          URL_PATH: "upload-vendor-documents",
          method: "POST",
          body: formData,
          bodyType: "FormData"
        });
    },

    submitWorksummaryandfiles: async (body) => {
        return await client({URL_PATH: "upload-vendor-work-samples", method: "POST", body: body})
    },
}

export default partners;
